class WorkScheduleTable {
  constructor (tableElement) {
    this.table = tableElement
  }

  static autoInit () {
    const table = document.querySelector('.schedule-table')
    if (table) {
      const instance = new WorkScheduleTable(table)
      instance.init()
      return instance
    }
    return null
  }

  init () {
    if (!this.table) return

    this.canEdit = this.table.dataset.canEdit === 'true'
    this.bindEvents()
    this.bindCopyButton()
  }

  bindEvents () {
    this.table.addEventListener('click', (e) => {
      if (!this.canEdit) return
      
      if (e.target.classList.contains('schedule-table__data-cell')) {
        this.handleDataCellClick(e.target)
      } else if (e.target.classList.contains('schedule-table__summary-cell')) {
        this.handleSummaryCellClick(e.target)
      }
    })
  }

  bindCopyButton () {
    const copyButton = document.getElementById('copy-from-previous-btn')
    if (copyButton && this.canEdit) {
      copyButton.addEventListener('click', () => {
        this.handleCopyFromPrevious(copyButton)
      })
    }
  }

  handleDataCellClick (cell) {
    const locationId = cell.dataset.locationId
    const shiftKey = cell.dataset.shiftKey
    const isCurrentlyNotWorking = cell.classList.contains('schedule-table__data-cell--not-working')

    const newNotWorkingStatus = !isCurrentlyNotWorking

    const updates = [{
      location_id: locationId,
      shift_key: shiftKey,
      not_working: newNotWorkingStatus
    }]

    this.updateCellAppearance(cell, newNotWorkingStatus)

    this.updateSchedule(updates)
  }

  handleSummaryCellClick (cell) {
    const summaryType = cell.dataset.summaryType
    const updates = []

    if (summaryType === 'row') {
      const locationId = cell.dataset.locationId
      const locationRow = cell.closest('tr')
      const dataCells = locationRow.querySelectorAll('.schedule-table__data-cell')

      const hasWorkingCells = Array.from(dataCells).some(cellItem =>
        !cellItem.classList.contains('schedule-table__data-cell--not-working')
      )
      const newNotWorkingStatus = hasWorkingCells

      dataCells.forEach(cellItem => {
        const shiftKey = cellItem.dataset.shiftKey
        updates.push({
          location_id: locationId,
          shift_key: shiftKey,
          not_working: newNotWorkingStatus
        })
      })

      dataCells.forEach(cellItem => {
        this.updateCellAppearance(cellItem, newNotWorkingStatus)
      })

      this.updateSchedule(updates)
    } else if (summaryType === 'column') {
      const shiftKey = cell.dataset.shiftKey
      const dataCells = this.table.querySelectorAll(`tbody tr:not(.schedule-table__summary-row) .schedule-table__data-cell[data-shift-key="${shiftKey}"]`)

      const hasWorkingCells = Array.from(dataCells).some(cellItem =>
        !cellItem.classList.contains('schedule-table__data-cell--not-working')
      )
      const newNotWorkingStatus = hasWorkingCells

      dataCells.forEach(cellItem => {
        const locationId = cellItem.dataset.locationId
        updates.push({
          location_id: locationId,
          shift_key: shiftKey,
          not_working: newNotWorkingStatus
        })
      })

      dataCells.forEach(cellItem => {
        this.updateCellAppearance(cellItem, newNotWorkingStatus)
      })

      this.updateSchedule(updates)
    }
  }

  handleCopyFromPrevious (button) {
    const originalText = button.textContent
    button.disabled = true
    button.textContent = 'Copying...'

    const url = `${window.location.pathname}/copy_from_previous`

    window.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCSRFToken(),
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          window.location.reload()
        } else {
          this.resetButtonState(button, originalText)
        }
      })
      .catch(() => {
        this.resetButtonState(button, originalText)
      })
  }

  resetButtonState (button, originalText) {
    button.disabled = false
    button.textContent = originalText
  }

  updateCellAppearance (cell, isNotWorking) {
    if (isNotWorking) {
      cell.classList.add('schedule-table__data-cell--not-working')
      cell.textContent = 'X'
    } else {
      cell.classList.remove('schedule-table__data-cell--not-working')
      cell.textContent = ''
    }
  }

  updateSchedule (updates, onSuccess) {
    const url = window.location.pathname

    const originalStates = updates.map(update => {
      const cell = this.table.querySelector(`[data-location-id="${update.location_id}"][data-shift-key="${update.shift_key}"]`)
      return {
        cell,
        wasNotWorking: !update.not_working
      }
    })

    window.fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCSRFToken(),
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          if (onSuccess) onSuccess()
        } else {
          this.revertChanges(originalStates)
        }
      })
      .catch(() => {
        this.revertChanges(originalStates)
      })
  }

  revertChanges (cellStates) {
    cellStates.forEach(({ cell, wasNotWorking }) => {
      if (cell) {
        this.updateCellAppearance(cell, wasNotWorking)
      }
    })
  }

  getCSRFToken () {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content') || ''
  }
}

document.addEventListener('turbolinks:load', () => {
  WorkScheduleTable.autoInit()
})
